import { createContext } from "react";
const memeContext = createContext();
export default memeContext;
